import gql from 'graphql-tag';
import { get } from 'lodash';

import * as Sentry from '@sentry/browser';

import universalRedirect from './universalRedirect';

const findRedirect = gql`
  query findRedirect($path: String!) {
    seoData(path: $path) {
      id
      canonicalPathV2
      shouldRedirect
    }
  }
`;

// Before 404-ing a request, check and see if there's a redirect we should invoke.
const maybeSEOFallback = async context => {
  try {
    const seoResponse = await context.apolloClient.query({
      query: findRedirect,
      variables: {
        path: context.asPath,
      },
      errorPolicy: 'none',
    });
    const seoData = get(seoResponse, ['data', 'seoData']);
    if (seoData && seoData.shouldRedirect) {
      return universalRedirect(context, seoData.canonicalPath);
    }
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
};

export default maybeSEOFallback;
